import { render, staticRenderFns } from "./Featured.vue?vue&type=template&id=8634f6ec&scoped=true&"
import script from "./Featured.vue?vue&type=script&lang=js&"
export * from "./Featured.vue?vue&type=script&lang=js&"
import style0 from "./Featured.vue?vue&type=style&index=0&id=8634f6ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8634f6ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
